// extracted by mini-css-extract-plugin
module.exports = {"bannerTextPreview":"bannerTextPreview_bannerTextPreview__1gvwF","description":"bannerTextPreview_description__287YX","button":"bannerTextPreview_button__3Qe1M"};